(ns frontend.view.settings2.account-information.events
  (:require
   [frontend.conn :as conn]
   [frontend.view.settings2.account-information.db :as db]))

(defn load-data-storage
  []
  (conn/send! :resources-limitation/query
              {}
              (fn [res]
                (swap! db/state assoc :resources-limitation (:body res)))
              30000))
